module.exports = __webpack_public_path__ + "static/media/img_landing03.eb52c194.png";